import { useEffect, useRef } from 'react'

/**
 * macOS-artiges Kontextmenue.
 *
 * items: Array von { label, onClick, icon?, danger?, disabled? } oder 'separator'
 * x, y: Position (clientX/clientY)
 * onClose: Callback zum Schliessen
 */
export default function ContextMenu({ items, x, y, onClose }) {
  const ref = useRef(null)

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose()
    }
    function handleKey(e) {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleKey)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleKey)
    }
  }, [onClose])

  // Position so anpassen, dass das Menue nicht aus dem Viewport ragt
  useEffect(() => {
    if (!ref.current) return
    const rect = ref.current.getBoundingClientRect()
    const pad = 8
    if (rect.right > window.innerWidth - pad) {
      ref.current.style.left = `${x - rect.width}px`
    }
    if (rect.bottom > window.innerHeight - pad) {
      ref.current.style.top = `${y - rect.height}px`
    }
  }, [x, y])

  return (
    <div ref={ref} className="context-menu" style={{ top: y, left: x }}>
      {items.map((item, i) => {
        if (item === 'separator') {
          return <div key={`sep-${i}`} className="context-menu-separator" />
        }
        if (item.type === 'colors') {
          return (
            <div key={`colors-${i}`} className="context-menu-colors">
              {item.colors.map(c => (
                <button
                  key={c.value || 'none'}
                  className="context-menu-color-dot"
                  style={{ background: c.value || 'transparent', border: c.value ? 'none' : '2px dashed var(--color-text-muted)' }}
                  title={c.label}
                  onClick={() => { item.onSelect(c.value); onClose() }}
                >
                  {!c.value && (
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="var(--color-text-muted)" strokeWidth="2.5">
                      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                    </svg>
                  )}
                </button>
              ))}
            </div>
          )
        }
        return (
          <button
            key={i}
            className={`context-menu-item ${item.danger ? 'context-menu-item-danger' : ''} ${item.disabled ? 'context-menu-item-disabled' : ''}`}
            onClick={() => {
              if (item.disabled) return
              item.onClick()
              onClose()
            }}
          >
            {item.icon && <span className="context-menu-icon">{item.icon}</span>}
            <span>{item.label}</span>
            {item.shortcut && <span className="context-menu-shortcut">{item.shortcut}</span>}
          </button>
        )
      })}
    </div>
  )
}
